import {CLIENT_SIGNUP_WORKFLOW_CANCELED_EVENT} from './client-signup-events';

Hop.defineModule('client-signup-workflow-cancel', (domRoot) => {
    function listenCancelButton() {
        domRoot.addEventListener('click', workflowCancel);
    }

    function workflowCancel(e) {
        e.preventDefault();
        return Hop.events.trigger(CLIENT_SIGNUP_WORKFLOW_CANCELED_EVENT, domRoot.parentElement);
    }

    listenCancelButton();

    return function destroy() {
        domRoot.removeEventListener('click', workflowCancel);
    };
});
